ui-cms-text-image-video {
  --component-tooltip-z-index: 65537;
}
